import { computed, Injectable, signal } from '@angular/core';
import {
  LeaderboardUser,
  LeaderboardUserWithPrize,
} from '../interfaces/leaderboard.interface';
import { Skin } from '@core/interfaces/skin.interface';
import { SocketService } from '@core/services/socket.service';

@Injectable({
  providedIn: 'root',
})
export class LeaderboardService {
  rewards = signal<Skin[]>([]);
  players = signal<LeaderboardUser[]>([]);

  pedestalPlayers = computed<LeaderboardUserWithPrize[]>(() =>
    this.players()
      .slice(0, 3)
      .map((player, i) => ({
        ...player,
        place: i + 1,
        prize: this.rewards()[i],
      }))
  );
  notPedestalPlayers = computed<LeaderboardUserWithPrize[]>(() =>
    this.players()
      .slice(3)
      .map((player, i) => ({
        ...player,
        place: i + 4,
        prize: this.rewards()[i + 3],
      }))
      .filter((player) => player.prize)
  );

  endTime = signal<number>(0);

  constructor(private socketService: SocketService) {
    this.socketService.socket.on(
      'update_lb_weekly',
      (
        data: {
          players: LeaderboardUser[];
          end: number;
          rewards: Skin[];
        }[]
      ) => {
        if (Array.isArray(data[0]?.players)) {
          this.players.set(data[0].players);
        }
        this.endTime.set(data[0].end);
        this.rewards.set(data[0].rewards);
      }
    );
  }
}
